import "./LoginForm.css";

import { setCookie } from "../../utils/SecurityUtils";
import LoadingOverlay from "../LoadingOverlay/LoadingOverlay";

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Form } from "react-bootstrap";
import axios from "axios";

export default function LoginForm() {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [countdown, setCountdown] = useState(0);
    const [isRedirecting, setIsRedirecting] = useState(false);

    useEffect(() => {
        let interval;
        if (countdown > 0) {
            interval = setInterval(() => {
                setCountdown(prev => prev - 1);
            }, 1000);
        } else if (countdown === 0 && isRedirecting) {
            navigate('/verify', { state: { email: email } });
        }
        return () => clearInterval(interval);
    }, [countdown, isRedirecting, navigate, email]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Get the token from the server
        setIsLoading(true);
        console.log("Logging in...");
        try {
            const response = await axios.post(
                "https://api.foveaai.com/evaluate/token",
                {
                    email: email,
                    password: password,
                }
            );

            // Handle the token
            const token = response.data.token;
            console.log(token);

            // Store the token in a cookie
            setCookie("AuthorizationToken", token, 30);

            // Navigate to the dashboard if the token is valid
            window.location.href = "/dashboard";
        } catch (error) {
            if (error.response && error.response.status === 401) {
                setError("Invalid email address or password");
            } else if (error.response && error.response.status === 403) {
                // Check if it's an unverified user
                if (error.response.data && error.response.data.error === 'user_not_verified') {
                    // Display the error message with countdown
                    setCountdown(10);
                    setIsRedirecting(true);
                    return;
                } else {
                    setError("Access denied. Please contact support if this issue persists.");
                }
            } else {
                setError(`Network error experienced while logging in. Please try again later and alert us if the error persists.`);
                console.error("Error fetching the token", error);
            }
        } finally {
            setIsLoading(false);
        }

        console.log(email, password);
    };

    return (
        <div className="login-form-container">
            {isLoading && <LoadingOverlay />}
            <Form className="login-form" onSubmit={handleSubmit}>
                <Form.Group controlId="formBasicEmail">
                    <Form.Label>Email address</Form.Label>
                    <Form.Control
                        type="email"
                        placeholder="Enter email"
                        onChange={(e) => setEmail(e.target.value)}
                    />
                </Form.Group>

                <Form.Group controlId="formBasicPassword" className="mt-2">
                    <Form.Label>Password</Form.Label>
                    <Form.Control
                        type="password"
                        placeholder="Password"
                        onChange={(e) => setPassword(e.target.value)}
                    />
                </Form.Group>

                <div className="d-flex justify-content-center">
                    <Button variant="primary" type="submit" className="mt-4">
                        Login
                    </Button>
                </div>

                {/* Display an error message if the login fails */}
                {error && (
                    <div className="alert alert-danger mt-4 d-flex justify-content-center">
                        {error}
                    </div>
                )}
                {/* Display verification countdown message */}
                {isRedirecting && countdown > 0 && (
                    <div className="alert alert-warning mt-4 d-flex justify-content-center flex-column">
                        <div>
                            Your email address has not been verified.
                            <br />
                            Redirecting to the verification page in {countdown} seconds.
                        </div>
                        <div className="d-flex justify-content-center">
                            <Button 
                                variant="primary" 
                                className="mt-2" 
                                onClick={() => navigate('/verify', { state: { email: email } })}
                            >
                                Verify Now
                            </Button>
                        </div>
                    </div>
                )}
            </Form>
        </div>
    );
}
